import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { fetchProfile } from 'store/session/actions';
import { getGroupId } from 'store/session/selectors';

import {
  shopVariablesFetch,
  shopVariablesValuesUpdate,
  types,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.SHOP_VARIABLES_VALUES_UPDATE_REQUEST,
    watchShopVariablesUpdate,
  );
}

export function* watchShopVariablesFetch() {
  try {
    const groupId = yield select(getGroupId);
    const {
      quoteDueDateDeltaHours,
      quoteExpireDateDeltaDays,
      taskDueDateDeltaHours,
    } = yield call(API.supplier.getShopVariables, groupId);
    yield put(
      shopVariablesFetch.success({
        quoteDueDateDeltaHours,
        quoteExpireDateDeltaDays,
        taskDueDateDeltaHours,
      }),
    );
  } catch (error) {
    console.error('ERROR FETCHING SHOP VARIABLES', error);
  }
}

export function* watchShopVariablesUpdate(action) {
  const {
    quoteDueDateDeltaHours,
    quoteExpireDateDeltaDays,
    taskDueDateDeltaHours,
  } = action.payload;
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(API.supplier.updateShopVariables, groupId, {
      quoteDueDateDeltaHours,
      quoteExpireDateDeltaDays,
    });
    yield call(API.supplier.update, groupId, { taskDueDateDeltaHours });
    yield put(
      shopVariablesValuesUpdate.success({
        quoteDueDateDeltaHours: response.quoteDueDateDeltaHours,
        quoteExpireDateDeltaDays: response.quoteExpireDateDeltaDays,
      }),
    );
    yield put(fetchProfile.request());
  } catch (e) {
    yield put(shopVariablesValuesUpdate.error(e));
  }
}

export function* initSaga() {
  yield call(watchShopVariablesFetch);
}
